import AbstractDevice from '../all/AbstractDevice';
import STBSEIRoboticsPlayerUtil from "./PlayerUtil";
import STBSEIRoboticsConfig from "./config";
import AndroidId from "../android/Id";
import SEIRoboticsPlayer from "./Player";
import SEIRoboticsKeys from "./Keys";
import AndroidNetworkStatus from "../android/NetworkStatus";
import AndroidSystem from "../android/System";

class STBSEIRoboticsDevice extends AbstractDevice {
  constructor () {
    super(
      "android",
      new AndroidId(),
      new SEIRoboticsPlayer(),
      new STBSEIRoboticsPlayerUtil(),
      STBSEIRoboticsConfig,
      new SEIRoboticsKeys(),
      new AndroidNetworkStatus(),
      new AndroidSystem(),
      "seirobotics"
    );
  }

  update_launcher(region, result){
  }

  getSubplatform() {
    return 'seirobotics';
  }

}

export default STBSEIRoboticsDevice;



// WEBPACK FOOTER //
// ./src/devices/seirobotics/Device.js